import React from 'react';
import Sorting from './Sorting';
import { createBrowserHistory } from 'history';
import '../css/regokas.css';
import TextField from "@mui/material/TextField";
import Loader from '../components/loader';
import Success from '../images/Success.svg';
import Error from '../images/Error.svg';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import Style from 'style-it';
import { RxCross2 } from 'react-icons/rx';
import { AiOutlinePlus } from 'react-icons/ai';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";


class Regokasbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasBoxData: [],
            kk: 'asdvhj',
            okasBoxType: '',
            registrationid: '',
            licenceid: '',
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            successmsgmodaldata: localStorage.getItem('dataadded'),
            usertype: localStorage.getItem('usertype'),
            fatchokasdata: '',
            loader: '',
            showmodels: '',
            currentPage: 1,
            todosPerPage: 10,
            on: false,
            tw: false,
            th: false,
            fo: false,
            fi: false,
            si: false,
            se: false,
            ei: false,
            ni: false,
            te: false,
        };
        this.handleClickpage = this.handleClickpage.bind(this);
    }
    state = {
        checkedA: true,
        checkedB: true,
        checkedF: true,
    };
    handleChange12 = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    componentWillMount() { }

    //------------------------------------------------ error msg function start--------------------------------------------------------
    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                })
            }
                .bind(this), 3000
        );
    }
    //------------------------------------------------ error msg function end ------------------------------------------------

    //------------------------------------------------ get data from id function start ------------------------------------------------

    checkregid = (edsf) => {
        this.setState({
            licenceid: '',
            okasboxtype: '',
            fatchokasdata: '',
        })
        let okasBox_serialNo = this.state.registrationid.trim();
        // console.log('data')
        if (okasBox_serialNo.length > 1) {
            // console.log('data00')
            let TokenValue = 'Token ' + localStorage.getItem("auth");
            var headers = {
                'Content-Type': 'application/json',
                'Authorization': TokenValue,
                'X-CSRFToken': localStorage.getItem('csrftoken')
            }
            let okasBox_serialNo = this.state.registrationid.trim();
            let tt = {
                okasBox_serialNo
            };
            this.setState({
                loader: true,
            })

            fetch('/we/we/checkregid/', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    this.setState({
                        licenceid: data.okasBox_version,
                        okasboxtype: data.okasBox_type,
                        fatchokasdata: '1',
                    })
                })
            this.setState({
                loader: false,
            })
        }
    }
    //------------------------------------------------ get data from id function end ------------------------------------------------
    //------------------------------------------------ Delete Succ msg start//------------------------------------------------
    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }
    //------------------------------------------------ Delete Succ msg start//------------------------------------------------


    componentDidMount() {
        const history = createBrowserHistory();
        const location = history.location;
        var test = location.pathname.split("/");
        let filteredbyurl = test[2];
        this.getallrealdata();
    }

    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }

        fetch('/we/we/okasunassigneddata/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                this.setState({
                    okasBoxData,
                    actualdata: okasBoxData
                })
                // console.log('okasunassigneddata:',this.state.okasBoxData)
                this.setState({
                    loader: false,
                })
            })
    }




    // ---------------------------------Change password function start----------------------------------------------
    changepasswordmodal = (pmid123, pmname123) => {
        this.setState({
            pmid: pmid123,
            pmname: pmname123
        })
    }
    // ---------------------------------Change password function end----------------------------------------------



    handleClickpage(event, position) {
        let pageNo = 0;
        if (position === 'position') {
            pageNo = event
        } else {
            pageNo = event.target.id
        }
        this.setState({
            currentPage: Number(pageNo)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }


    //------------------------------------------------ print main data(List view) function start----------------------------
    renderTableData = (type) => {
        if (this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }

        ///-------------------------pagination start,,,,-----------------------------------------------
        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.okasBoxData.slice(indexOfFirstTodo, indexOfLastTodo);
        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }
        ///-------------------------pagination end,,,,-----------------------------------------------
        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                const dateFromString = new Date(e.assigned_at);
                const dateOnly = dateFromString.toISOString().split('T')[0];
                // if(e.okas_box_number===1 && e.okas_box_number===qwerty  ){
                let pmid = e.okas_box_number;
                let pmname = e.okasBox_type;
                typee = typee + 1;
                return (

                    <tr key={index}>
                        <td className="qwerty">{index + 1}</td>
                        {/* <td   className="qwerty">{e.okas_box_number}</td> */}
                        <td>{e.okasBox_type === "Master Controller" ? "Master Studio" :
                            e.okasBox_type === "VOD Box" ? "Media Studio" :
                                e.okasBox_type === "UVOD Box" ? "Ultra Media Studio" :
                                    e.okasBox_type === "Core Okas" ? "Core OKAS" :
                                        e.okasBox_type === "Audio Box" ? "Music Studio" : e.okasBox_type}</td>
                        <td>{e.okasBox_serialNo}</td>
                        <td className="qwerty">{e.okasBox_version}</td>
                        <td style={{ color: (e.okasBox_status === 'Assigned Project' ? 'green' : 'red') }}> {e.okasBox_status === 'Assigned SI' ? 'UNASSIGNED' : e.okasBox_status}</td>
                        {/* <td  className="qwerty">{e.assigned_at.substring(0, 10)} {e.assigned_at.substring(11, 19)}</td>  */}
                        <td>{dateOnly}</td>
                        {this.state.usertype === '2' ?
                            <td>{'IP:' + e.ip}<br />{'SM:' + e.subnet_mask}<br />{'GW:' + e.gateway}</td>
                            :
                            ''
                        }

                        {this.state.usertype === '2' ?
                            <td><a className="button" data-toggle="modal" data-target="#hometheaterbox" onClick={(e) => { this.changepasswordmodal(pmid, pmname) }} ><b>Config</b></a></td>
                            :
                            ''
                        }
                    </tr>
                )
                // }            
            });
            return xx;
        }
    }
    //------------------------------------------------ print main data(List view) function end--------------------------------

    // ----------------------------------------------submit change password start--------------------------------------------------
    onPasswordChangekHandler = (buttonaction, pmids) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')

        }
        let ipaddress = this.state.ipaddress;
        let subnetmask = this.state.subnetmask;
        let defaultgateway = this.state.defaultgateway;
        let ip = ipaddress;
        let subnet_mask = subnetmask;
        let gateway = defaultgateway;
        // (/^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$/.test(value) ? true : false)
        let tt = {
            ip,
            subnet_mask,
            gateway,
        };
        // console.log(tt)
        // console.log(pmids)
        if (ipaddress.length < 1) {
            this.setState({
                error: 'Enter a IP Address',
                ipaddress: 'errorfield'
            })
        } else if (subnetmask.length < 1) {
            this.setState({
                error: 'Enter a Subnet Mask',
                subnetmask: 'errorfield'
            })
        } else if (defaultgateway.length < 1) {
            this.setState({
                error: 'Enter a Default Gateway',
                defaultgateway: 'errorfield'
            })
        } else {
            if (buttonaction === 'add') {
                this.setState({
                    disabledvalue: 'disabled',
                })
            }
            fetch('/we/we/updateiprequest/' + pmids, {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tt)
            })
                // .then(response => response.json()) 
                .then(response => {
                    response.json()
                    if (response.status == 200) {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        })
                        this.getallrealdata();
                        this.oncolseClickHandler();
                        this.errormsg();
                        if (buttonaction === 'add') {
                            this.onclosemodel();
                            const history = createBrowserHistory({ forceRefresh: true });
                            history.push('/regOkas');
                        } else if (buttonaction === 'addanother') {
                        }
                    } else {
                        alert('Action not completed.');
                    }
                })
                .then(data => { })
        }
    }
    // ----------------------------------------------submit change password start--------------------------------------------------


    oncolseClickHandler = (event) => {
        this.setState({
            okasboxtype: '',
            registrationid: '',
            licenceid: ''
        })
    }

    // --------------------------------------------------------open model function start----------------------------

    onopenmodel = (event) => {
        this.setState({
            showmodels: 'true',
        })
        this.props.searchBarActivate(false)
    }

    // --------------------------------------------------------open model function end----------------------------

    // --------------------------------------------------------close model function start----------------------------

    onclosemodel = (event) => {
        this.setState({
            showmodels: '',
        })
        this.oncolseClickHandler();
    }

    // --------------------------------------------------------close model function End----------------------------



    // ----------------------------Submit all data in data base POST API Start--------------------------------------
    onAddClickHandler = (buttonaction) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        let okasBox_serialNo = this.state.registrationid.trim();
        let okasBox_version = this.state.licenceid.trim();
        let okasBox_type = this.state.okasboxtype.trim();
        let okas_box_number = new Date().valueOf().toString();
        let tt = [{
            okasBox_serialNo,
            okasBox_version,
            okasBox_type,
            okas_box_number
        }];
        if (okasBox_type.length < 1) {
            this.setState({
                error: 'Please Select aOkas Box Type id of okas box',
                okasboxtypeerror: 'errorfield selectlistss'
            })
        } else if (okasBox_serialNo.length < 1) {
            this.setState({
                error: 'Please enter a valid registration id of okas box',
                registrationiderror: 'errorfield',
            })
        } else if (okasBox_version.length < 1) {
            this.setState({
                error: 'Please enter a valid license id of okas box',
                licenceiderror: 'errorfield'
            })
        } else if (okasBox_serialNo.length < 1) {
            this.setState({
                error: 'Registration ID cannot blank',
                registrationiderror: 'errorfield'
            })
        } else {
            if (buttonaction === 'add') {
                this.setState({
                    disabledvalue: 'disabled',
                })
            }
            this.setState({
                loader: true,
            })
            fetch('/we/we/insertokasbox/', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => {
                    response.json()
                    if (response.status == 200) {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        })
                        this.getallrealdata();
                        this.oncolseClickHandler();
                        this.errormsg();
                        if (buttonaction === 'add') {
                            this.onclosemodel();

                        } else if (buttonaction === 'addanother') {
                        }
                    } else {
                        alert('Action not completed.');
                    }
                })
                .then(data => {
                    this.setState({
                        loader: false,
                    })
                })
        }
    }
    //----------------------------------------- Submit all data in data base POST API End----------------------------------------


    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };


    //-------------------------------------------Render data after sorting Function Start----------------------------------------------
    restoreData = (data) => {
        this.setState({
            okasBoxData: data,

        })
    }
    //-----------------------------------------------Render data after sorting Function End--------------------------------------------------


    //------------------------------------------------------- sorting Function Start----------------------------------------------
    sortingFunc = (type, searchValue) => {
        if (type !== "search") {
            this.props.searchBarActivate(false)
        }
        if (type == "okas_box_number") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                on: !this.state.on,
            })
        }
        if (type == "okasBox_type") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                tw: !this.state.tw,
            })
        }
        if (type == "okasBox_serialNo") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                th: !this.state.th,
            })
        }
        if (type == "okasBox_version") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                fo: !this.state.fo,
            })
        }
        if (type == "okasBox_assigned_to") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                fi: !this.state.fi,
            })
        }
        if (type == "assigned_at") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                si: !this.state.si,
            })
        }
        if (type == "okasBox_status") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                fi: !this.state.fi,
            })
        }
        if (type == "ip") {
            this.setState({
                on: false,
                tw: false,
                th: false,
                fo: false,
                fi: false,
                si: false,
                se: false,
                ei: false,
                ni: false,
                te: false,
                se: !this.state.se,
            })
        }
        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.okasBoxData);
        } else if (type === 'search') {
            type = 'search';
            let sendingData = this.state.actualdata.map((e) => {
                let returnData = {
                    okasBox_type: e.okasBox_type,
                    okasBox_serialNo: e.okasBox_serialNo,
                    okasBox_version: e.okasBox_version,
                    okasBox_status: e.okasBox_status,
                    okasBox_assigned_to: e.okasBox_assigned_to,
                    assigned_at: e.assigned_at.substring(0, 10) + ' ' + e.assigned_at.substring(11, 19),
                }
                return returnData
            })
            Sorting(this.restoreData, type, sendingData, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.okasBoxData);
        }
    }
    //---------------------------------------------------------- sorting Function End--------------------------------------------------


    onSearchClick = () => {
        this.props.searchBarActivate(!this.props.redux.globalVar.searchBarShow)
    }

    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: "S.NO"; }
      td:nth-of-type(2):before { content: "TYPE"; }
      td:nth-of-type(3):before { content: "SERIAL NO."; }
      td:nth-of-type(4):before { content: "VERSION"; }
      td:nth-of-type(5):before { content: "STATUS"; }
      td:nth-of-type(6):before { content: "DATE OF PURCHASE
      "; }
    }`,
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : ""
                }}

            >
                {this.state.loader ? <Loader /> : null}
                <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                    <div className="inblksuccfull"><img src={Success} /></div>
                    <div className="inblksucc1">
                        SUCCESS !
                        <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                    </div>
                </div>
                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>
                        <input type="text" ref={input => input && input.focus()} name="namess" id="namess" placeholder="Search"
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e.target.value
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }}
                        />
                    </div>
                    : ''}
                {this.state.usertype !== '200' ? '' :
                    <div className="addregOkasButton">
                        <a className="addregOkasButtonicon" data-toggle="modal" data-target="#regiokasbox" onClick={this.onopenmodel.bind(this)}>
                            <AiOutlinePlus size={42} style={{ color: " #15599F" }} />   ADD NEW OKAS BOX
                        </a>
                    </div>
                }
                <div className='row'>
                    <h3>OKAS Inventory</h3>
                    <div className="tests">
                    <TableContainer component={Paper}>
                <Table className={"tablecontent"}>
                    <TableHead>
                        {this.props.redux.globalVar.userTypeStyle === "2" ? (
                            <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>
                                    Type
                                    {this.state.statustw ? (
                                        <IoIosArrowUp onClick={() => this.sortingFunc("statustw")} />
                                    ) : (
                                        <IoIosArrowDown onClick={() => this.sortingFunc("statustw")} />
                                    )}
                                </TableCell>
                                <TableCell>
                                    Serial No.
                                    {this.state.statusth ? (
                                        <IoIosArrowUp onClick={() => this.sortingFunc("statusth")} />
                                    ) : (
                                        <IoIosArrowDown onClick={() => this.sortingFunc("statusth")} />
                                    )}
                                </TableCell>
                                <TableCell>
                                    Version
                                    {this.state.statusfo ? (
                                        <IoIosArrowUp onClick={() => this.sortingFunc("statusfo")} />
                                    ) : (
                                        <IoIosArrowDown onClick={() => this.sortingFunc("statusfo")} />
                                    )}
                                </TableCell>
                                <TableCell>
                                    Status
                                    {this.state.statusfi ? (
                                        <IoIosArrowUp onClick={() => this.sortingFunc("statusfi")} />
                                    ) : (
                                        <IoIosArrowDown onClick={() => this.sortingFunc("statusfi")} />
                                    )}
                                </TableCell>
                                <TableCell>
                                    DATE OF PURCHASE
                                    {this.state.statussi ? (
                                        <IoIosArrowUp onClick={() => this.sortingFunc("statussi")} />
                                    ) : (
                                        <IoIosArrowDown onClick={() => this.sortingFunc("statussi")} />
                                    )}
                                </TableCell>
                                <TableCell>
                                    Ips
                                    {this.state.statusse ? (
                                        <IoIosArrowUp onClick={() => this.sortingFunc("statusse")} />
                                    ) : (
                                        <IoIosArrowDown onClick={() => this.sortingFunc("statusse")} />
                                    )}
                                </TableCell>
                                <TableCell>Config Ip Address</TableCell>
                            </TableRow>
                        ) : (
                            <TableRow>
                                <TableCell sx={{ color: 'white' , position: "relative" , fontSize:'11px'}}>S.No</TableCell>
                                <TableCell sx={{ color: 'white' , position: "relative" , fontSize:'11px'}}>
                                    Type
                                    <span style={{ position: "absolute", right: 0, top: "60%", transform: "translateY(-50%)" }}>
                                    {this.state.statustw ? (
                                        <IoIosArrowUp sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statustw")} />
                                    ) : (
                                        <IoIosArrowDown sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statustw")} />
                                    )}
                                    </span>
                                </TableCell>
                                <TableCell sx={{ color: 'white' , position: "relative" , fontSize:'11px'}}>
                                    Serial No.
                                    <span style={{ position: "absolute", right: 0, top: "60%", transform: "translateY(-50%)" }}>
                                    {this.state.statusth ? (
                                        <IoIosArrowUp sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statusth")} />
                                    ) : (
                                        <IoIosArrowDown sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statusth")} />
                                    )}
                                    </span>
                                </TableCell>
                                <TableCell sx={{ color: 'white' , position: "relative" , fontSize:'11px'}}>
                                    Version
                                    <span style={{ position: "absolute", right: 0, top: "60%", transform: "translateY(-50%)" }}>
                                    {this.state.statusfo ? (
                                        <IoIosArrowUp sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statusfo")} />
                                    ) : (
                                        <IoIosArrowDown sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statusfo")} />
                                    )}
                                    </span>
                                </TableCell>
                                <TableCell sx={{ color: 'white' , position: "relative" , fontSize:'11px'}}>
                                    Status
                                    <span style={{ position: "absolute", right: 0, top: "60%", transform: "translateY(-50%)" }}>
                                    {this.state.statusfi ? (
                                        <IoIosArrowUp sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statusfi")} />
                                    ) : (
                                        <IoIosArrowDown sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statusfi")} />
                                    )}
                                    </span>
                                </TableCell>
                                <TableCell sx={{width: "20%", color: 'white' , position: "relative" , fontSize:'11px'}}>
                                    DATE OF PURCHASE
                                    <span style={{ position: "absolute", right: 0, top: "60%", transform: "translateY(-50%)" }}>
                                    {this.state.statussi ? (
                                        <IoIosArrowUp sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statussi")} />
                                    ) : (
                                        <IoIosArrowDown sx={{ float: "right", color: 'white' }} onClick={() => this.sortingFunc("statussi")} />
                                    )}
                                    </span>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableHead>
                    <TableBody>{this.renderTableData("type1")}</TableBody>
                </Table>
            </TableContainer>
                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.okasBoxData.length ?
                                <ul className="pagination pull-right paginat">
                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.okasBoxData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.okasBoxData.length}  of {this.state.okasBoxData.length} enteries</span>
                                    </li>
                                    <li>
                                        <a style={{ pointerEvents: this.state.currentPage === 1 ? 'none' : '' }}
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1, 'position')
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>
                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className="" style={{ pointerEvents: Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage) === Number(this.state.currentPage) ? 'none' : '' }}
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.okasBoxData.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1, 'position')
                                            }

                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>
                    </div>
                </div>
                {this.state.showmodels ?
                    <div className="selfmodal fade" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog">
                            <div className="selfmodal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>&times;</button>
                                    <h4 className="modal-title">ADD OKAS BOX</h4> {this.state.error !== '' ? <div className="alert alert-danger">{this.state.error}</div> : null}
                                </div>
                                <div className="modal-body modfields">
                                    <div className="md-form">
                                    </div>  <br />
                                    <TextField label="Registration Id" type="text" name="registrationid" placeholder="Registration Id" className={this.state.registrationiderror ? this.state.registrationiderror : ""}
                                        value={this.state.registrationid}
                                        onChange={(e) => {
                                            this.setState({
                                                registrationid: e.target.value
                                            }, () => console.log(this.state.registrationid))

                                        }}

                                        onKeyUp={(e) => { this.checkregid(e.target.value) }}
                                    />   <br />

                                    <TextField label="OKAS Box Type" readOnly type="text" name="okasboxtype" placeholder="OKAS Box Type" className={this.state.okasboxtypeerror ? this.state.okasboxtypeerror : ""}
                                        value={this.state.okasboxtype}
                                        onChange={(e) => {
                                            this.setState({
                                                okasBoxType: e.target.value
                                            }, () => console.log(this.state.okasBoxType))

                                        }} />
                                    <br />
                                    <TextField label="License Id" type="text" readOnly name="licenceid" placeholder="License Id" className={this.state.licenceiderror ? this.state.licenceiderror : ""}
                                        value={this.state.licenceid}
                                        onChange={(e) => {
                                            this.setState({
                                                licenceid: e.target.value
                                            }, () => console.log(this.state.licenceid))
                                        }}
                                    />   <br />

                                    <span className="fieldmend"></span>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn allbtn" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>Cancel</button>
                                    <button type="button" disabled={this.state.licenceid ? null : 'disabled'} className="btn addbtn allbtn" onClick={this.onAddClickHandler.bind(this, 'addanother')}>Add Another</button>
                                    <button type="button" disabled={this.state.licenceid ? null : 'disabled'} className="btn btn-primary allbtn" onClick={this.onAddClickHandler.bind(this, 'add')}>Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}



                {/*config modal start */}

                <div className="modal fade" id="hometheaterbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Config IP Form</h4> {this.state.error !== '' ? <div className="alert alert-danger">{this.state.error}</div> : null}
                            </div>
                            <div className="modal-body modfields">

                                <TextField label="IP Address" type="text" name="ipaddress" placeholder="IP Address" value={this.state.ipaddress}
                                    onChange={(e) => {
                                        this.setState({
                                            ipaddress: e.target.value
                                        }, () => console.log(this.state.ipaddress))

                                    }}
                                />   <br />
                                <TextField label="Subnet Mask" type="text" name="subnetmask" placeholder="Subnet Mask" value={this.state.subnetmask}
                                    onChange={(e) => {
                                        this.setState({
                                            subnetmask: e.target.value
                                        }, () => console.log(this.state.subnetmask))

                                    }}
                                />   <br />
                                <TextField label="Default Gateway" type="text" name="defaultgateway" placeholder="Default Gateway" value={this.state.defaultgateway}
                                    onChange={(e) => {
                                        this.setState({
                                            defaultgateway: e.target.value
                                        }, () => console.log(this.state.defaultgateway))

                                    }}
                                />   <br />
                                <span className="fieldmend"></span>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn allbtn" data-dismiss="modal" onClick={this.oncolseClickHandler.bind(this)}>Cancel</button>
                                <button type="button" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.onPasswordChangekHandler.bind(this, 'add', this.state.pmid)}>Update </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*config modal end */}
            </div>
        );
    }

}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Regokasbox);
